import {
  AlertDescription as ChakraAlertDescription,
  AlertDescriptionProps as ChakraAlertDescriptionProps,
} from '@chakra-ui/react';

const AlertDescription = (props: ChakraAlertDescriptionProps) => <ChakraAlertDescription {...props} />;

export { AlertDescription };
